import { format } from 'date-fns'

export const formatDate = (date: number | string, formatOutput = 'HH:mm dd MMM yyyy'): string => {
  if (!date) return ''
  let dateObject: Date
  if (typeof date === 'number') {
    dateObject = new Date(Math.floor(date))
  } else {
    dateObject = new Date(date)
  }
  return format(dateObject, formatOutput)

  // const day = date.getDate().toString().padStart(2, '0')
  // const year = date.getFullYear().toString()
  // const month = (date.getMonth() + 1).toString().padStart(2, '0')
  // const hours = date.getHours().toString().padStart(2, '0')
  // const minutes = date.getMinutes().toString().padStart(2, '0')
  // // const seconds = date.getSeconds().toString().padStart(2, '0')
  // return `${day}/${month}/${year}, ${hours}:${minutes}`
}

export const formatTime = (secs: number): string => {
  const seconds = Math.floor(secs)
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const remainingSeconds = seconds % 60

  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`
}

const ONE_HOUR = 60 * 60 * 1000
const ONE_DAY = 24 * ONE_HOUR

// 1 day vs 2 days
const padS = (n: number, unit: string) => {
  return `${n} ${unit}${n > 1 ? 's' : ''}`
}
// ex: 60 => 1 minute
export const formatTimeDuration = (seconds: number) => {
  if (seconds < 60) return `1 min`

  const min = Math.floor(seconds / 60)
  if (min < 60) return padS(min, 'min')

  const hour = Math.floor((seconds * 1000) / ONE_HOUR)
  if (hour < 24) return padS(hour, 'hour')

  const day = Math.floor((seconds * 1000) / ONE_DAY)
  if (day < 30) return padS(day, 'day')

  const month = Math.floor((seconds * 1000) / (ONE_DAY * 30))
  return padS(month, 'month')
}

// 123232323232 => 1 mins ago
export const formatTimeRecent = (timestamp: number, postfix = 'ago') => {
  const delta = (Date.now() - timestamp) / 1000
  if (delta < 60) return `a few secs ${postfix}`
  return `${formatTimeDuration(delta)} ${postfix}`
}
